const toLang = (locale: string) => locale.split('-')[0];
const onlyAcceptable = (options: string[]) => (lang: string) =>
  options.includes(lang);

export const detectLanguage = (options: string[]): string =>
  navigator.languages.map(toLang).filter(onlyAcceptable(options))[0] ||
  options[0];
